function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M20.8,88.4c0,3.7,3,6.6,6.7,6.6h45.1c3.7,0,6.7-2.9,6.7-6.6L81.9,34H18.3L20.8,88.4z M62,44.9c0-1.9,1.1-3.4,3-3.4     s3,1.5,3,3.4v37.6c0,1.9-1.1,3.4-3,3.4s-3-1.5-3-3.4V44.9z M47,44.9c0-1.9,1.1-3.4,3-3.4s3,1.5,3,3.4v37.6c0,1.9-1.1,3.4-3,3.4     s-3-1.5-3-3.4V44.9z M32,44.9c0-1.9,1.1-3.4,3-3.4s3,1.5,3,3.4v37.6c0,1.9-1.1,3.4-3,3.4s-3-1.5-3-3.4V44.9z"
}), React.createElement("path", {
  d: "M83.1,17H65V8.1C65,6.3,64.1,5,62.2,5H38c-1.9,0-3,1.3-3,3.1V17H17.1c-1.9,0-3.1,1.4-3.1,3.3v3.8c0,1.9,1.2,3.9,3.1,3.9     h66.1c1.9,0,2.9-2.1,2.9-3.9v-3.8C86,18.4,85,17,83.1,17z M59,17H41v-6h18V17z"
}))));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.9e515398.svg";
export { ForwardRef as ReactComponent };